<template>
	<div v-if="show" class="user-info" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" @click.stop>
		<div class="user-info-box">
			<div class="avatar">
				<head-image :name="user.nickName" :url="user.headImageThumb" :size="60" :online="user.online"
					@click.native="showFullImage()" radius="10%"> </head-image>
			</div>
			<div class="info-card">
				<div class="header">
					<div class="nick-name">{{ user.nickName }}</div>
					<div v-if="user.sex == 0" class="icon iconfont icon-man" style="color: darkblue;"></div>
					<div v-if="user.sex == 1" class="icon iconfont icon-girl" style="color: darkred;"></div>
				</div>
				<div class="info-item">
					用户名: {{ user.userName }}
				</div>
				<div class="info-item">
					个性签名: {{ user.signature }}
				</div>
			</div>
		</div>
		<el-divider content-position="center"></el-divider>
		<div class="btn-group">
			<div class="btn-row">
				<el-button v-if="isFriend" type="primary" @click="onSendMessage()">发消息</el-button>
				<el-button v-else type="primary" @click="onAddFriend()">加为好友</el-button>
				<el-switch
					v-if="showAdminSwitch"
					v-model="memberIsAdmin"
					active-text="管理员"
					inactive-text="普通成员"
					@change="onToggleMemberAdmin"
					class="admin-switch">
				</el-switch>
				<el-switch
					v-if="showMuteSwitch"
					v-model="memberIsMuted"
					active-text="已禁言"
					inactive-text="未禁言"
					@change="onToggleMemberMuted"
					class="mute-switch">
				</el-switch>
			</div>
		</div>
	</div>


</template>

<script>
import HeadImage from './HeadImage.vue'

export default {
	name: "userInfo",
	components: {
		HeadImage
	},
	data() {
		return {
			show: false,
			user: {},
			pos: {
				x: 0,
				y: 0
			},
			groupId: null,
			groupOwnerId: null,
			canMute: false,
			memberInfo: null,
			memberIsMuted: false,
			memberIsAdmin: false
		}
	},
	methods: {
		open(user, pos, groupInfo = null) {
			this.show = true;
			this.user = user;
			let w = document.documentElement.clientWidth;
			let h = document.documentElement.clientHeight;
			this.pos.x = Math.min(pos.x, w - 430);
			this.pos.y = Math.min(pos.y, h - 200);
			
			// 设置群聊相关信息
			if (groupInfo) {
				this.groupId = groupInfo.groupId;
				this.groupOwnerId = groupInfo.groupOwnerId;
				this.canMute = !!groupInfo.canMute;
				this.memberInfo = groupInfo.memberInfo;
				this.memberIsMuted = this.memberInfo ? this.memberInfo.isMuted : false;
				this.memberIsAdmin = this.memberInfo ? this.memberInfo.isAdmin : false;
			} else {
				this.groupId = null;
				this.groupOwnerId = null;
				this.canMute = false;
				this.memberInfo = null;
				this.memberIsMuted = false;
				this.memberIsAdmin = false;
			}
		},
		close() {
			this.show = false;
		},
		onSendMessage() {
			let user = this.user;
			let showName = user.nickName;
			if (this.isFriend && this.friendInfo) {
				const r = this.friendInfo.remark != null && String(this.friendInfo.remark).trim();
				showName = r ? String(this.friendInfo.remark).trim() : user.nickName;
			}
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName,
				headImage: user.headImageThumb
			};
			if (this.isFriend) {
				chat.isDnd = this.friendInfo.isDnd;
			}
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.show = false;
		},
		onAddFriend() {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: this.user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: this.user.id,
					nickName: this.user.nickName,
					headImage: this.user.headImageThumb,
					online: this.user.online,
					deleted: false
				}
				this.friendStore.addFriend(friend);
			})
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$eventBus.$emit("openFullImage", this.user.headImage);
			}
		},
		onToggleMemberMuted(value) {
			if (!this.groupId || !this.user.id) {
				return;
			}
			this.$http({
				url: '/group/member/muted',
				method: 'put',
				data: {
					groupId: this.groupId,
					userId: this.user.id,
					isMuted: value
				}
			}).then(() => {
				this.$message.success(value ? '已禁言该成员' : '已解除禁言');
				// 更新成员信息
				if (this.memberInfo) {
					this.memberInfo.isMuted = value;
				}
				// 触发重新加载群成员列表
				this.$eventBus.$emit('reloadGroupMembers', this.groupId);
			}).catch((err) => {
				// 如果失败，恢复原状态
				this.memberIsMuted = !value;
				this.$message.error(err.message || '操作失败');
			});
		},
		onToggleMemberAdmin(value) {
			if (!this.groupId || !this.user.id) {
				return;
			}
			this.$http({
				url: '/group/member/admin',
				method: 'put',
				data: {
					groupId: this.groupId,
					userId: this.user.id,
					isAdmin: value
				}
			}).then(() => {
				this.$message.success(value ? '已设为管理员' : '已取消管理员');
				if (this.memberInfo) {
					this.memberInfo.isAdmin = value;
				}
				this.$eventBus.$emit('reloadGroupMembers', this.groupId);
			}).catch((err) => {
				this.memberIsAdmin = !value;
				this.$message.error(err.message || '操作失败');
			});
		}
	},
	computed: {
		isFriend() {
			return this.friendStore.isFriend(this.user.id);
		},
		friendInfo() {
			return this.friendStore.findFriend(this.user.id);
		},
		showMuteSwitch() {
			// 只有在群聊场景且当前用户有权限时才显示禁言开关
			// 不能禁言自己
			return this.groupId &&
				this.canMute &&
				this.user.id != this.mine.id;
		},
		showAdminSwitch() {
			// 仅群主可设置管理员，不能设置自己/群主本人
			return this.groupId &&
				this.mine.id == this.groupOwnerId &&
				this.user.id != this.mine.id &&
				this.user.id != this.groupOwnerId;
		},
		mine() {
			return this.userStore.userInfo;
		}
	}
}
</script>

<style lang="scss" scoped>
.user-info-mask {
	background-color: rgba($color: #f4f4f4, $alpha: 0);
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
}

.user-info {
	position: absolute;
	width: 380px;
	background-color: white;
	box-shadow: var(--im-box-shadow);
	border-radius: 4px;
	padding: 15px;

	.user-info-box {
		display: flex;
		align-items: center;

		.info-card {
			flex: 1;
			padding-left: 10px;

			.header {
				display: flex;
				align-items: center;

				.nick-name {
					font-size: var(--im-font-size-large);
					font-weight: 600;
				}

				.icon {
					margin-left: 3px;
					font-size: var(--im-font-size);
				}
			}

			.info-item {
				font-size: var(--im-font-size);
				margin-top: 5px;
				word-break: break-all;
			}
		}
	}

	.el-divider--horizontal {
		margin: 18px 0;
	}

	.btn-group {
		text-align: center;
		.btn-row {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: flex-start;
			gap: 12px;
		}

		.mute-switch {
			flex: 0 0 auto;
		}

		.admin-switch {
			flex: 0 0 auto;
		}
	}
}
</style>